import {makeStyles, Theme, createStyles} from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minHeight: "100vh",
      backgroundColor: "#f8fafc"
    },
    container: {
      paddingTop: "20px",
      paddingBottom: "20px"
    },
    header: {
      marginBottom: "20px",
      textAlign: "center"
    },
    heading: {
      fontWeight: 700,
      fontSize: "2.5rem",
      lineHeight: 1.2
    },
    subheading: {
      color: "#64748b",
      maxWidth: 800,
      margin: "0 auto"
    },
    tabsWrapper: {
      marginBottom: "10px",
      display: "flex",
      justifyContent: "center",
      backgroundColor: "#f8fafc"
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column"
    },
    thumbnailWrapper: {
      position: "relative",
      cursor: "pointer",
      "&:hover $overlay": {
        backgroundColor: "rgba(0, 0, 0, 0.5)"
      },
      "&:hover $playButton": {
        transform: "scale(1.1)"
      }
    },
    thumbnail: {
      height: 220,
      objectFit: "cover",
      width: "100%"
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background-color 0.3s ease"
    },
    playButton: {
      width: 64,
      height: 64,
      borderRadius: "50%",
      backgroundColor: "#f97316",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "transform 0.3s ease",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    },
    metadataOverlay: {
      position: "absolute",
      top: 16,
      left: 16,
      right: 16,
      display: "flex",
      justifyContent: "space-between",
      zIndex: 1
    },
    durationChip: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      color: "#fff",
      padding: "4px 12px",
      borderRadius: 16,
      fontSize: 14
    },
    cardContent: {
      padding: "14px",
      display: "grid",
      gridTemplateRows: "auto auto auto 1fr auto", // Fixed rows for consistent alignment
      gap: "12px",
      flexGrow: 1,
      minHeight: "380px",
    },
    videoTitle: {
      fontWeight: 600,
      lineHeight: 1.3,
      height: "50px", // Fixed height for titles
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
    creatorInfo: {
      display: "flex",
      gap: "16px",
      alignItems: "flex-start",
    },
    creatorTextContent: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    creatorAvatar: {
      width: 48,
      height: 48,
      border: "2px solid #f97316",
      flexShrink: 0,
    },
    creatorText: {
      display: "flex",
      alignItems: "center",
      gap: "2px",
      height: "24px", // Fixed height for creator/date line
    },
    companyInfo: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      height: "28px", // Fixed height for company line
    },
    companyLogo: {
      background: "#f8f9fa",
      padding: "4px 8px",
      borderRadius: "4px",
      border: "1px solid #dee2e6",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    companyLogoInverted: {
      background: "#f8f9fa",
      padding: "4px 8px",
      borderRadius: "4px",
      border: "1px solid #dee2e6",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        filter: "invert(1)", // Inverts the colors
      },
    },
    videoDescription: {
      color: "#64748b",
      lineHeight: 1.4,
      height: "63px", // Fixed height for 3 lines of description
      display: "-webkit-box",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
    actionButtons: {
      display: "flex",
      gap: "15px",
      marginRight: 5,
    },
    watchVideoButton: {
      display: "flex",
      width: "50%",
      justifyItems: "center",
      alignItems: "center",
      backgroundColor: "#ff6900",
      color: "white",
      borderRadius: "5px"
    },
    modalDownloadButton: {
      display: "flex",
      width: "100%",
      justifyItems: "center",
      alignItems: "center",
      backgroundColor: "#ff6900",
      color: "white",
      borderRadius: "5px"
    },
    ScheduleButton: {
      display: "flex",
      width: "50%",
      justifyItems: "center",
      alignItems: "center",
      backgroundColor: "white",
      color: "#ff6900",
      border: "1px solid #ff6900",
      borderRadius: "5px"
    },
    modalScheduleButton: {
      display: "flex",
      width: "100%",
      justifyItems: "center",
      alignItems: "center",
      backgroundColor: "white",
      color: "#ff6900",
      border: "1px solid #ff6900",
      borderRadius: "5px"
    },
    TabsX: {
      backgroundColor: "#f1f5f9",
      borderRadius: "8px",
      padding: 8
    },
    tabRoot: {
      textTransform: "none",
      fontWeight: 500,
      color: "black", // Inactive color
      "&.Mui-selected": {
        backgroundColor: "white",
        fontWeight: 600,
        display: "flex",
        justifyItems: "center",
        alignItems: "center",
        borderRadius: "5px"
      }
    },
    closeButton: {
      position: "absolute",
      right: 8,
      top: 8,
      color: "#555",
      zIndex: 10,
    }
  });

const useStyles = makeStyles(styles);

export default useStyles;
